var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{attrs:{"dense":"","color":"cyan","filled":"","id":_vm.id,"items":_vm.timeList,"placeholder":_vm.placeholder,"solo":"","flat":"","item-color":"cyan","hide-details":"","disabled":_vm.disabled},on:{"change":function($event){return _vm.emitValue()}},model:{value:(_vm.time),callback:function ($$v) {_vm.time=$$v},expression:"time"}})
}
var staticRenderFns = []

export { render, staticRenderFns }